<template>
  <DragPanel
    title="移动到"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div
      v-if="loading"
      class="loading-box">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      v-else
      class="common-tree-box">
      <el-tree
        class="dialog-tree-small-primary"
        ref="tree"
        :data="treeData"
        :props="defaultProps"
        node-key="nodeId"
        highlight-current
        :expand-on-click-node="false"
        :default-expand-all="true"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick">
        <template slot-scope="{ data }">
          <div class="custom-node-box">
            <icon-svg
              class="icon"
              icon-class="ic-ico_folder" />
            <span
              :title="data.nodeName"
              class="text-overflow">
              {{ data.nodeName }}
            </span>
          </div>
        </template>
      </el-tree>
    </div>
    <div
      class="common-checkbox-box"
      v-if="treeData.length">
      <el-checkbox
        class="checkbox-primary"
        v-model="isOnlyMoveLeafNodes">
        仅移动{{ nodesToMove.dataTypeName }}
      </el-checkbox>
    </div>
    <div class="operation-btn-box">
      <div class="common-button-box">
        <el-button
          size="small"
          class="normal-btn primary-ang-btn"
          @click="closePanel">
          取消
        </el-button>
        <el-button
          size="small"
          class="primary-btn primary-ang-btn"
          type="primary"
          @click="submit">
          确定
        </el-button>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import Spin from '@/components/Spin.vue'

import {
  getSingleSceneTreeById,
  dataSetTreeNodeMoveService
} from '@/service/interface'

export default {
  data() {
    return {
      loading: true,
      treeData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },
      targetNode: {},

      isOnlyMoveLeafNodes: false
    }
  },
  props: {
    nodesToMove: Object,
    closeMoveToPanel: Function,
    updateDataSetTree: Function
  },
  components: { DragPanel, Spin },
  mounted() {
    this.initDataSetData()
  },
  methods: {
    initDataSetData() {
      this.loading = true
      let sceneId = this.$route.query.sceneId
      getSingleSceneTreeById({ sceneId }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let treeData = this.formatData(data)
          this.treeData = treeData

          this.loading = false
          this.$nextTick(() => {
            this.$refs.tree.filter()
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleNodeClick(nodeData) {
      this.targetNode = nodeData
    },
    submit() {
      let targetId = this.targetNode.nodeId
      if (!targetId) {
        this.$message.warning('请选择需要移动到的目录！')
        return
      }

      let isExceptionPass = true
      if (this.isOnlyMoveLeafNodes) {
        let dataSets = this.nodesToMove.nodes.filter(el => el.nodeType === 2)
        if (!dataSets.length) {
          let warningMsg = `所选数据中没有${this.nodesToMove.dataTypeName}，请重新选择`
          this.$message.warning(warningMsg)
          return
        }
        isExceptionPass = this.handleExistException(dataSets, targetId)
      } else {
        let nodes = this.nodesToMove.nodes
        isExceptionPass = this.handleExistException(nodes, targetId)
      }
      if (!isExceptionPass) return

      if (this.isOnlyMoveLeafNodes) {
        let dataSets = this.nodesToMove.nodes.filter(el => el.nodeType === 2)
        isExceptionPass = this.handleEqualException(dataSets, targetId)
      } else {
        let nodes = this.nodesToMove.nodes
        isExceptionPass = this.handleEqualException(nodes, targetId)
      }

      const targetNode = this.$refs.tree.getNode(targetId)
      const nodesToMoveNodeType = this.nodesToMove.nodes.map(el => el.nodeType)[0]
      // prettier-ignore
      if (nodesToMoveNodeType === 1 && targetNode.level > window.maxLevel) {
        this.$message.error(`文件夹最多支持${window.maxLevel + 1}级，请选择其他目录！`)
        return
      }

      if (!isExceptionPass) return

      let moveNodeIds = []
      if (this.isOnlyMoveLeafNodes) {
        let dataSets = this.nodesToMove.nodes.filter(el => el.nodeType === 2)
        moveNodeIds = dataSets.map(item => item.nodeId)
      } else {
        moveNodeIds = this.nodesToMove.nodes.map(item => item.nodeId)
      }

      let params = { targetId, nodeIds: moveNodeIds }
      dataSetTreeNodeMoveService(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('移动成功')
          this.updateDataSetTree()
          this.closePanel()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    // 处理需要移动的节点已在目标节点的异常
    handleExistException(nodes, targetId) {
      let isExceptionPass = true
      let invalidNodes = nodes.filter(item => item.parentId === targetId)
      if (invalidNodes.length) {
        let invalidNodeNames = this.getInvalidNodeNames(invalidNodes)
        let warningMessage = `${invalidNodeNames}已在当前目录中，请选择其他目录或重新选择！`
        this.$message.warning(warningMessage)

        isExceptionPass = false
      }

      return isExceptionPass
    },
    // 处理需要移动的节点就是目标节点的异常
    handleEqualException(targetId) {
      let isExceptionPass = true
      let nodes = this.nodesToMove.nodes
      let invalidNodes = nodes.filter(item => item.nodeId === targetId)
      if (invalidNodes.length) {
        let invalidNodeNames = this.getInvalidNodeNames(invalidNodes)
        let warningMessage = `${invalidNodeNames}不能移动到自身目录之下，请选择其他目录或重新选择！`
        this.$message.warning(warningMessage)

        isExceptionPass = false
      }
      return isExceptionPass
    },
    getInvalidNodeNames(invalidNodes) {
      let nodeNames = invalidNodes.map(el => el.nodeName)
      let string = ''
      if (nodeNames.length > 2) {
        string = `${nodeNames[0]},${nodeNames[0]}等${nodeNames.length}个节点`
      } else {
        string = nodeNames.join(',')
      }
      return string
    },
    filterNode(value, nodeData) {
      let nodeType = nodeData.nodeType
      if (nodeType === 2) {
        return false
      } else {
        return true
      }
    },
    formatData(data) {
      let rootFolders = this.findAllNodeByLevel(data, 3)
      let folders = this.findAllNodeByLevel(data, 1)
      let allFolders = [...rootFolders, ...folders]
      allFolders.forEach(item => {
        item['nodeName'] = item.sceneNodeName
        item['nodeId'] = item.sceneNodeId
      })

      let leafNodes = this.findAllNodeByLevel(data, 2)
      leafNodes.forEach(item => {
        let findLastIndex = item.sceneNodeName.lastIndexOf('.')
        if (findLastIndex !== -1) {
          item['nodeName'] = item.sceneNodeName.substring(0, findLastIndex)
          item['sceneNodeName'] = item.nodeName
        } else {
          item['nodeName'] = item.sceneNodeName
        }
        item['nodeId'] = item.sceneNodeId
      })

      let dataSetType = this.nodesToMove.dataSetType
      data = data.filter(el => el.dataSetType === dataSetType)

      return data
    },
    findAllNodeByLevel(data, level) {
      const array = []

      const traverse = item => {
        if (item.nodeType === level) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    },
    closePanel() {
      this.closeMoveToPanel()
    },
    // 打开其他面板前的校验
    openOtherPanelCheck() {
      return new Promise(resolve => {
        this.closeMoveToPanel()
        resolve(true)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 360px;
  height: 440px;
  min-width: 360px;
  min-height: 440px;

  /deep/ .content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);

    .loading-box {
      flex-grow: 1;
    }

    .common-tree-box {
      padding: 16px;
      color: var(--default-color);
      height: calc(100% - 95px);
      overflow: auto;

      .dialog-tree-primary {
        background-color: transparent;
      }

      // .dialog-tree-primary > .el-tree-node > .el-tree-node__children {
      //   .custom-node-box .text-overflow{
      //     font-size: 13px;
      //   }
      // }

      .custom-node-box {
        display: flex;
        align-items: center;
        font-size: 14px;
        overflow: hidden;

        .text-overflow {
          font-size: 14px;
          font-weight: 400;
        }

        .icon {
          color: var(--icon-color);
          margin-right: 5px;
          vertical-align: middle;
        }
      }
    }

    .common-checkbox-box {
      margin-left: 15px;
      line-height: 32px;
      text-align: left;
    }

    .operation-btn-box {
      padding: 15px;
      text-align: right;
      border-top: 1px solid var(--dialog-split-line-color);

      // .common-button-box {
      //   .el-button {
      //     flex-grow: 1;
      //     text-align: center;
      //     border-radius: 4px;
      //     margin-right: 0px;
      //   }

      //   .el-button--default {
      //     border-color: #929292;
      //     background: transparent;
      //   }
      // }
    }
  }
}
</style>
